var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component_type,{tag:"component",staticClass:"btn waves-effect waves-light",class:[
        {
        'btn-small':_vm.small,
        'btn-sm':_vm.small
        },
        _vm.cls,
        _vm.btn_type
        ],on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b8cc9c2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/Shared/Resources/Assets/js/components/base/buttons/BaseButton.vue
// module id = D3NQ
// module chunks = 0